import request from '@/utils/request'

//  管理后台-菜单权限列表
export const menuList = () => {
    return request.get(`/menu/menuPermissionsList`)
}
